import styled from 'styled-components';
import {
  FacebookShareButton,
  PinterestShareButton,
  CopyShareButton,
  EmailShareButton,
  TwitterShareButton,
} from '@minerva-analytics/pantheon';
import { WHITE, TABLET } from '../../theme';

const ShareAndSubscribe = styled.div`
  width: 46.875rem;
  margin: 4.5rem auto 8rem auto;
  @media (max-width: ${TABLET}) {
    width: 90%;
    margin: 4.5rem auto 3rem auto;
  }
`;

const ArticleContainer = styled.div`
  margin: 0 auto;
  position: relative;
  justify-content: center;
`;

const ShareText = styled.div`
  font-size: 1rem;
  text-align: center;
  justify-content: center;
  display: flex;
  color: white;
  font-family: Roboto, sans-serif;
  margin-bottom: 0.9rem;
`;

const ShareButtonContainer = styled.div`
  justify-content: center;
  display: flex;
`;

const ShareContainer = styled.div`
  margin: 1rem auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const FacebookShare = styled(FacebookShareButton)`
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
`;

const PinterestShare = styled(PinterestShareButton)`
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
`;

const CopyShare = styled(CopyShareButton)`
  width: 2.5rem;
  height: 2.5rem;
`;

const EmailShare = styled(EmailShareButton)`
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
`;

const TwitterShare = styled(TwitterShareButton)`
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
`;

const SubscriptionContainer = styled.div`
  font-family: Roboto, sans-serif;
  color: ${WHITE};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 4.5rem 1rem 0 0;
  width: 46.875rem;
  @media (max-width: ${TABLET}) {
    width: 90%;
  }
`;

const SubscribeTitle = styled.div`
  font-weight: 700;
  font-size: 1.625rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.9375rem;
  @media (max-width: 37.5rem) {
    font-size: 1.375rem;
  }
`;

const SubscribeSubTitle = styled.div`
  font-weight: 300;
  font-size: 1.375rem;
  margin-bottom: 2.25rem;
  @media (max-width: 37.5rem) {
    font-size: 1rem;
  }
`;

export {
  ArticleContainer,
  ShareAndSubscribe,
  ShareText,
  ShareButtonContainer,
  FacebookShare,
  PinterestShare,
  CopyShare,
  EmailShare,
  TwitterShare,
  SubscriptionContainer,
  SubscribeTitle,
  SubscribeSubTitle,
  ShareContainer,
};